<template>
  <div v-loading="loading">
    <el-form
      ref="form"
      :model="form"
      label-width="110px"
      id="feedback-form"
      :rules="rules"
      v-if="isShow"
    >
      <el-form-item label="请选择车系:" prop="inputList">
        <carSearch
          @increment="appAddCounter"
          :inputList.sync="row"
          :searchType="2"
        ></carSearch>
      </el-form-item>
      <el-form-item label="标题:" prop="title">
        <el-input v-model="form.title"></el-input>
      </el-form-item>
      <el-form-item label="内容:" prop="content">
        <el-input type="textarea" v-model="form.content"></el-input>
      </el-form-item>
      <el-form-item label="评分:" prop="score_num">
        <el-input v-model="form.score_num"></el-input>
      </el-form-item>
      <!--            <el-form-item label="购车全款价:" prop="score_price_all">
                <el-input v-model="form.score_price_all"></el-input>
            </el-form-item>-->
      <el-form-item label="上传图片:" prop="score_logo">
        <uploadImage
          @setImgFun="getImgUrl"
          :fileListArr.sync="row.score_logo"
        ></uploadImage>
      </el-form-item>
      <el-form-item label="审核状态:" prop="review_type">
        <el-radio-group v-model="form.review_type">
          <el-radio :label="0">未审核</el-radio>
          <el-radio :label="1">已审核</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="类型:" prop="score_type">
        <el-select v-model="form.score_type" placeholder="请选择">
          <el-option
            v-for="item in typeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="onSubmit('form')">提交</el-button>
        <el-button @click="close(2)">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import uploadImage from "../../components/upload-image/upload-image";
import carSearch from "../../components/car-search/car-search";
import { AllEdit } from "../../api/api";
export default {
  name: "car-series-form",
  components: {
    carSearch,
    uploadImage,
  },
  props: {
    layerid: String,
    edit: Boolean,
    keyword: Array,
    row: {
      default: function () {
        return [];
      },
    },
    seriesid: Number,
  },
  data() {
    var inputListChange = (rule, value, callback) => {
      if (
        typeof this.form.seriesid == "undefined" ||
        this.form.seriesid == ""
      ) {
        callback(new Error("请选择车系"));
      } else {
        callback();
      }
    };
    let data = {
      bt: "创建",
      form: {},
      loading: true,
      rules: {
        inputList: [
          { validator: inputListChange, required: true, trigger: "blur" },
        ],
        title: [
          { required: true, message: "请输入标题", trigger: "blur" },
          {
            min: 2,
            max: 50,
            message: "长度在 2 到 50 个字符",
            trigger: "blur",
          },
        ],
        content: [{ required: true, message: "请输入内容", trigger: "blur" }],
        score_num: [{ required: true, message: "请输入评分", trigger: "blur" }],
        score_type: [
          { required: true, message: "请选择类型", trigger: "change" },
        ],
      },
      typeOptions: [
        {
          value: "0",
          label: "用户评分",
        },
        {
          value: "1",
          label: "专家评分",
        },
        {
          value: "2",
          label: "安全评分",
        },
        {
          value: "3",
          label: "常见问题",
        },
      ],
      logName: "",
      optionSeries: [],
      where: {
        series_name: "",
      },
      listSearch: [],
      options: [],
      inputList: [],
      isShow: false,
    };
    return data;
  },
  async mounted() {
    if (this.seriesid) this.form.seriesid = this.seriesid;

    if (this.edit) {
      let msg = await AllEdit("api/car-score/" + this.row.id);
      let { data } = msg;
      data = JSON.parse(data).data;
      this.form = data;
      this.isShow = true;
      this.loading = false;
    } else {
      this.isShow = true;
      this.loading = false;
    }
  },
  methods: {
    onSubmit(e) {
      if (this.logName == "admin") this.form.userid = 1;
      this.$refs[e].validate((valid) => {
        if (valid) {
          this.$emit("emitcarscor", { form: this.form });
        } else {
          this.$message.error("请检查表单完整性");
          return false;
        }
      });
    },
    close(e) {
      this.$emit("emitcarscor", {});
    },
    appAddCounter: function (e) {
      this.form.brandid = e["brandid"];
      this.form.modelid = e["modelid"];
      if (e["seriesid"])
        this.form.seriesid = e["seriesid"] ? e["seriesid"] : "";
      if (e["modelid"]) this.form.modelid = e["modelid"] ? e["modelid"] : "";
    },
    getImgUrl(e) {
      this.form.score_logo = JSON.stringify(e); //上传文件列表
    },
  },
  watch: {},
};
</script>

<style scoped lang="scss">
.el-select {
  width: 100%;
}
</style>
<style>
</style>
